import { EAuthenticationActionTypes, IModalOpenPayload, TModalOpen } from './types';

export const modalOpen = (payload: IModalOpenPayload = { autoRefresh: true, alert: null }): TModalOpen => ({
  type: EAuthenticationActionTypes.ModalOpen,
  payload,
});
